<template>
  <div class="flex items-center justify-between">
    <div
      v-for="step in totalSteps"
      :key="step"
      class="flex items-center flex-1"
    >
      <div 
        :class="[
          'w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold',
          currentStep >= step 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
        ]"
      >
        {{ step }}
      </div>
      <div 
        v-if="step < totalSteps" 
        :class="[
          'flex-1 h-1 mx-2',
          currentStep > step ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-700'
        ]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  currentStep: number
  totalSteps?: number
}

const props = withDefaults(defineProps<Props>(), {
  totalSteps: 4
})
</script>
